import { IonButton, IonContent } from "@ionic/react";
interface Props {
  setGraphAsseDesc: Function;
  graphNameToShowInfo: string;
}
const GraphAromDescriptionModal: React.FC<Props> = ({
  setGraphAsseDesc,
  graphNameToShowInfo,
}) => {
  console.log("graphNameToShowInfo", graphNameToShowInfo);

  function getGraphTitleFirstDesc() {
    if (graphNameToShowInfo === "Shoulder Abduction") {
      return "Data indicates AROM of shoulder abduction in the frontal plane.";
    } else if (graphNameToShowInfo === "Shoulder Adduction") {
      return "Data indicates AROM of shoulder adduction in the frontal plane.";
    } else if (graphNameToShowInfo === "Shoulder Flexion") {
      return "Data indicates AROM of shoulder flexion in the sagittal plane.";
    } else if (graphNameToShowInfo === "Shoulder Extension") {
      return "Data indicates AROM of shoulder extension in the sagittal plane.";
    } else if (graphNameToShowInfo === "Elbow Flexion") {
      return "Data indicates AROM of elbow flexion in the frontal plane.";
    } else if (graphNameToShowInfo === "Elbow Extension") {
      return "Data indicates AROM of elbow extension in the frontal plane.";
    } else if (graphNameToShowInfo === "Internal Rotation") {
      return "Data indicates AROM of shoulder internal rotation in the frontal plane.";
    } else if (graphNameToShowInfo === "External Rotation") {
      return "Data indicates AROM of shoulder external rotation in the frontal plane.";
    }
  }
  function getGraphAssessmentImage() {
    if (graphNameToShowInfo === "Shoulder Abduction" || graphNameToShowInfo === "Shoulder Adduction") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="80"
          viewBox="0 0 62 80"
          fill="none"
        >
          <path
            d="M30.9979 17.4116C35.1648 17.4116 38.5397 14.0767 38.5397 9.95903C38.5397 5.84139 35.1648 2.50647 30.9979 2.50647C26.8309 2.50647 23.4561 5.84139 23.4561 9.95903C23.4561 14.0767 26.8309 17.4116 30.9979 17.4116Z"
            fill="black"
          />
          <path
            d="M43.0277 27.3203C42.8507 27.3661 42.6906 27.4036 42.5516 27.4327C42.7075 27.3869 42.8676 27.337 43.0235 27.2828C43.0235 27.2953 43.0277 27.3078 43.0277 27.3203Z"
            fill="black"
          />
          <path
            d="M61.1756 2.50244C61.1672 4.72988 60.8764 11.6245 55.8331 18.2028C52.6268 22.3912 48.1692 25.6012 43.0163 27.2832C42.8604 27.3374 42.7003 27.3873 42.5444 27.4331C42.4643 27.4539 42.3885 27.4706 42.3211 27.4831V28.7946C42.3211 44.8738 42.3127 60.9488 42.3042 77.028C41.8745 78.735 40.3114 79.9466 38.5291 79.9424C36.7511 79.9383 35.1922 78.7309 34.7624 77.028V54.6704H27.2206V77.028C26.8077 78.531 25.628 79.6801 24.2039 79.9424C22.3501 80.2838 20.3361 79.0806 19.6788 77.028V27.5039C14.231 25.8843 9.51637 22.5786 6.1668 18.2028C1.1277 11.6245 0.832767 4.72988 0.824341 2.50244C1.4437 1.05356 2.84251 0.0793192 4.40143 0.0043773C6.09517 -0.0747281 7.6878 0.924498 8.36614 2.50244C8.36614 12.7487 16.8138 21.0964 27.1827 21.1338C29.7107 21.1422 35.8158 21.3587 36.7638 21.1338C36.827 21.1172 37.6443 20.9173 38.7609 20.705C38.8788 20.6842 38.9589 20.6675 38.9631 20.6675C47.3476 18.769 53.6338 11.3456 53.6338 2.50244C54.3121 0.924498 55.9048 -0.0747281 57.5985 0.0043773C59.1616 0.0793192 60.5562 1.05356 61.1756 2.50244Z"
            fill="black"
          />
          <path
            d="M42.5392 27.4367C42.4633 27.4617 42.3917 27.4867 42.3159 27.5075V27.4867C42.3833 27.4742 42.4591 27.4575 42.5392 27.4367Z"
            fill="black"
          />
        </svg>
      );
    } else if (graphNameToShowInfo === "Shoulder Flexion" || graphNameToShowInfo === "Shoulder Extension") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="80"
          viewBox="0 0 20 80"
          fill="none"
        >
          <path
            d="M11.7984 54.0815C11.7984 52.0366 10.2265 50.3789 8.28756 50.3789C6.34857 50.3789 4.77672 52.0366 4.77672 54.0815V76.2972C4.77672 78.3421 6.34857 79.9998 8.28756 79.9998C10.2265 79.9998 11.7984 78.3421 11.7984 76.2972V54.0815Z"
            fill="black"
          />
          <path
            d="M4.98634 24.5688C4.48004 24.7403 3.03136 25.3054 1.92267 26.88C0.78442 28.5014 0.714203 30.1812 0.714203 30.7346V49.3607C0.714203 52.9347 3.46374 55.8345 6.85263 55.8345H9.36195C12.7508 55.8345 15.5004 52.9347 15.5004 49.3607V30.7346C15.5004 30.3176 15.4634 29.7291 15.2897 29.0548C15.2897 29.0548 14.946 27.718 14.0221 26.5292C12.8802 25.0599 9.38043 23.8906 4.98634 24.5688Z"
            fill="black"
          />
          <path
            d="M8.32733 31.2044L7.75451 31.0291C7.16321 30.7952 6.19496 30.2963 5.6517 29.2635C5.13062 28.2735 5.22301 27.2056 5.34866 26.4456C5.75887 24.0019 8.20907 14.9051 11.8271 2.67872C12.3629 0.714391 14.3068 -0.419779 16.1731 0.145357L16.7459 0.320744C18.6085 0.88588 19.684 2.93596 19.1481 4.90419L12.6697 28.6711C12.1338 30.6354 10.1899 31.7696 8.32363 31.2044H8.32733Z"
            fill="black"
          />
          <path
            d="M9.43351 7.76784C8.98634 7.6665 8.52438 7.61194 8.05135 7.61194C4.40007 7.61194 1.43619 10.7338 1.43619 14.5884C1.43619 17.5739 3.21378 20.1112 5.71202 21.1089C6.60636 17.6947 7.89613 13.0645 9.42981 7.76784H9.43351Z"
            fill="black"
          />
        </svg>
      );
    } else if (
      graphNameToShowInfo === "Elbow Flexion" ||
      graphNameToShowInfo === "Elbow Extension"
    ) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="80"
          viewBox="0 0 30 80"
          fill="none"
        >
          <path
            d="M9.53706 15.4194C13.8158 15.4194 17.2813 11.9694 17.2813 7.70951C17.2813 3.44966 13.8158 -0.000427246 9.53706 -0.000427246C5.25827 -0.000427246 1.79285 3.44966 1.79285 7.70951C1.79285 11.9694 5.25827 15.4194 9.53706 15.4194Z"
            fill="black"
          />
          <path
            d="M12.1382 40.2231H11.9997C11.0522 40.2231 10.1264 40.0594 9.24814 39.7407C8.716 39.5468 7.10226 38.9524 5.83031 37.3028C4.50643 35.5799 4.33338 33.7192 4.35069 32.7587V24.0667C4.35069 22.6238 4.91311 21.2713 5.93414 20.2591C6.95516 19.2469 8.31364 18.6826 9.75865 18.6826C12.7395 18.6826 15.1666 21.099 15.1666 24.0667V29.5584H18.2686V25.5613C18.2686 21.6116 15.0498 18.407 11.0825 18.407H8.14924C4.18196 18.407 0.963135 21.6116 0.963135 25.5613V46.1412C0.963135 49.2424 2.94894 51.8871 5.72215 52.8734V75.9084C5.72215 78.1697 7.56085 80.0003 9.8322 80.0003C12.1035 80.0003 13.9423 78.1697 13.9423 75.9084V52.7054C16.4862 51.6071 18.2686 49.0787 18.2686 46.1412V40.2748L12.1382 40.2231Z"
            fill="black"
          />
          <path
            d="M29.0369 34.9422C29.0369 37.4403 27.0035 39.4647 24.4942 39.4647C20.3798 39.4303 16.2611 39.3958 12.1467 39.3614C11.554 39.3743 10.6152 39.3183 9.55088 38.9306C9.01874 38.7368 7.61699 38.2027 6.52242 36.777C5.26345 35.136 5.21153 33.3614 5.22018 32.7713V24.0664C5.22018 22.8173 5.72637 21.6845 6.54838 20.8661C7.37039 20.0478 8.50823 19.5438 9.76288 19.5438C12.2722 19.5438 14.3056 21.5682 14.3056 24.0664V30.4196H24.4942C27.0035 30.4196 29.0369 32.444 29.0369 34.9422Z"
            fill="black"
          />
        </svg>
      );
    } else if (
      graphNameToShowInfo === "Internal Rotation" ||
      graphNameToShowInfo === "External Rotation"
    ) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="30"
          viewBox="0 0 80 30"
          fill="none"
        >
          <path
            d="M27.3892 8.99263C26.8716 9.07143 26.4122 9.18699 25.4774 9.49166C24.5902 9.78058 23.3755 10.2113 21.9285 10.8207L2.9586 19.3095C0.434211 20.4389 -0.695955 23.3911 0.444773 25.9073C1.58022 28.4182 4.54823 29.5423 7.0779 28.4129L20.8247 22.2617C24.5479 26.1121 32.3904 29.1431 39.5042 29.2797C47.1671 29.4215 55.4427 26.2224 59.2609 22.0673L72.9233 28.1818C75.4477 29.3112 78.4157 28.1818 79.5564 25.6761C79.8574 25.009 80 24.3156 80 23.6327C80 22.2144 79.3927 20.8486 78.3153 19.8978C77.7502 19.3988 77.2063 19.1519 77.0373 19.0784C75.1308 18.2326 67.5946 14.834 57.2541 10.1956C56.6468 9.86988 55.8018 9.49692 54.7561 9.25003C53.9428 9.06092 53.214 8.99788 52.6278 8.98738H52.0469C52.1261 9.50742 52.1789 10.0327 52.1789 10.5738C52.1789 16.3993 46.903 21.1165 41.0515 21.1165C34.3867 21.1165 30.0456 15.0021 29.9241 10.5738C29.9083 9.96969 29.9717 9.43388 30.0562 8.98738C29.433 8.89282 28.4982 8.81928 27.3945 8.98738L27.3892 8.99263Z"
            fill="black"
          />
          <path
            d="M31.5625 10.1186C31.5625 15.3138 35.7927 19.5214 41.0158 19.5214C46.2388 19.5214 50.469 15.3138 50.469 10.1186C50.469 4.92334 46.2388 0.715698 41.0158 0.715698C35.7927 0.715698 31.5625 4.92334 31.5625 10.1186Z"
            fill="black"
          />
        </svg>
      );
    }
  }
  function getGraphTitleLiDesc() {
    if (graphNameToShowInfo === "Shoulder Abduction") {
      return (
        <>
          <li>
            Placing your hand behind your head requires ~120<sup>o</sup>.
          </li>
          <li>
            Combing hair requires ~120<sup>o</sup>.
          </li>
          <li>
            Lifting a shopping bag requires ~40<sup>o</sup>-50<sup>o</sup>.
          </li>
        </>
      );
    } else if (graphNameToShowInfo === "Shoulder Adduction") {
      return (
        <>
          <li>
            Washing contralateral armpit requires ~115<sup>o</sup>.
          </li>
          <li>
            Combing hair requires ~85<sup>o</sup>.
          </li>
          <li>
            Turning a key/unlocking a door requires ~40<sup>o</sup>.
          </li>
        </>
      );
    } else if (graphNameToShowInfo === "Shoulder Flexion") {
      return (
        <>
          <li>
            Combing hair requires up to ~140<sup>o</sup>.
          </li>
          <li>
            Reaching an object from a shelf at head level requires ~105
            <sup>o</sup>.
          </li>
          <li>
            Washing contralateral armpit requires ~90<sup>o</sup>.
          </li>
        </>
      );
    } else if (graphNameToShowInfo === "Shoulder Extension") {
      return (
        <>
          <li>
            Washing lower back requires ~60<sup>o</sup>.
          </li>
          <li>
            Peri care requires between ~40<sup>o</sup>-50<sup>o</sup>.
          </li>
          <li>
            Tucking in shirt behind back requires ~45<sup>o</sup>.
          </li>
        </>
      );
    } else if (graphNameToShowInfo === "Elbow Flexion") {
      return (
        <>
          <li>
            Using a cellphone ~140<sup>o</sup>-150<sup>o</sup>.
          </li>
          <li>
            Sit to stand ~100<sup>o</sup>-110<sup>o</sup>.
          </li>
          <li>
            Fastening button on pants ~70<sup>o</sup>.
          </li>
        </>
      );
    } else if (graphNameToShowInfo === "Elbow Extension") {
      return (
        <>
          <li>
            Opening a door ~10<sup>o</sup>-20<sup>o</sup>.
          </li>
          <li>
            Sit to stand ~20<sup>o</sup>.
          </li>
          <li>
            Turning a page ~70<sup>o</sup>-75<sup>o</sup>.
          </li>
        </>
      );
    } else if (graphNameToShowInfo === "Internal Rotation") {
      return (
        <>
          <li>
            Donning and zipping pants ~79<sup>o</sup>.
          </li>
          <li>
            Completing pericare with ipsilateral limb ~65<sup>o</sup>.
          </li>
          <li>
            Reaching for box off shelf ~23<sup>o</sup>.
          </li>
        </>
      );
    } else if (graphNameToShowInfo === "External Rotation") {
      return (
        <>
          <li>
            Reaching for a can off shelf ~46<sup>o</sup>.
          </li>
          <li>
            Drinking from a cup ~53<sup>o</sup>.
          </li>
          <li>
            Box off the ground ~45<sup>o</sup>.
          </li>
        </>
      );
    }
  }
  return (
    <>
      <div className="graph-assessment-modal-desc">
        <div className="d-flex justify-content-end">
          <svg
            onClick={() => {
              setGraphAsseDesc(false);
            }}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20.9999 20.909L2.90845 2.90918M21 2.90918L2.90845 20.9091"
              stroke="#D1D1D1"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="text-center mb-32">{getGraphAssessmentImage()}</div>
        <h1 className="assesment-modal-info text-center mb-24">
          {graphNameToShowInfo}
        </h1>
        <div className="description-wrap">
          <h6 className="assesment-modal-desc text-black fw-600  mb-8 mt-0">
            {getGraphTitleFirstDesc()}
          </h6>
          <h6 className="assesment-modal-desc dark-slate-gray fw-400">
            Measured in degrees of motion at the end range where participant
            unable to achieve further motion without compensation or pain.
            Differential Diagnosis is required, but limitations in motion may be
            caused by swelling, pain, weakness, contracture, or injury.
          </h6>
          <ul className="mb-32">{getGraphTitleLiDesc()}</ul>
          <div className="d-flex justify-content-center">
            <IonButton
              placeholder={undefined}
              className="blue-btn w-50"
              onClick={() => {
                setGraphAsseDesc(false);
              }}
            >
              Close
            </IonButton>
          </div>
        </div>
      </div>
    </>
  );
};
export default GraphAromDescriptionModal;
